var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClosevector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 188,
    viewBox: "0 0 41 188",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6151 124.681C61.3961 123.513 63.5758 167.477 62.8472 167.725L62.6151 124.681ZM62.8472 167.725C62.2023 167.944 62.3977 168.118 61.7533 167.899C61.0245 167.651 60.3388 167.018 58.9683 165.752L25.7626 135.075C24.3919 133.809 23.7065 133.176 23.2081 132.29C22.767 131.507 22.4339 130.583 22.2302 129.58C22 128.447 22 127.18 22 124.648L22 63.2956C22 60.7624 22 59.4965 22.2302 58.3627C22.4339 57.3603 22.767 56.4365 23.2081 55.6528C23.7065 54.7671 24.3919 54.1341 25.7626 52.8676L58.9683 22.1911C60.3388 20.9245 61.0245 20.2922 61.7532 20.0441M62.8472 167.725L61.9243 95.1399L62.8472 167.725ZM61.7532 20.0441C62.3977 19.8247 59.6879 20.5057 62.1015 20.2976C62.8297 20.5457 61.518 93.6999 61.9243 95.1399M61.7532 20.0441L61.9243 95.1399L61.7532 20.0441Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_84",
    x: 0,
    y: -0.0000152588,
    width: 81,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_84"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_84",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClosevector);
export default __webpack_public_path__ + "static/media/icon-closevector.6bd8d5efe28ec25d8010d4b0c618cfc2.svg";
export { ForwardRef as ReactComponent };